/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: outboundRoutesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Calls Routing module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteOutboundRoute } from './api/outboundRouteApi';

/**
 * Shared helpers for Outbound Routes actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate an Outbound Route in the form.
 * Pattern: /pbx/calls-routing/outbound/new?duplicate={id}
 */
export const getOutboundRouteDuplicateUrl = (id: string | number): string =>
  `/pbx/calls-routing/outbound/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Outbound Route id.
 */
export const navigateToOutboundRouteDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getOutboundRouteDuplicateUrl(id));
};

/**
 * Low-level API helper to delete an Outbound Route by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteOutboundRouteById = async (id: string | number): Promise<void> => {
  await deleteOutboundRoute(id);
};



